import React from 'react';
import ReactDOM from "react-dom";
import {Wrapper} from "@atttomyx/react-components";
import App from "./app";
import {branding, storage} from "@atttomyx/react-utils";
import {themes} from "@atttomyx/shared-constants";
import {app} from "./konstants";
import "./themes/light.css";
import "./themes/dark.css";

storage.setNamespace(app.namespace);

ReactDOM.render(
    <Wrapper
        theme={themes.DARK}
        branding={branding.BRANDING_DARK}
    >
        {(onThemeChange, snackbar, dimensions) =>
            <App
                onThemeChange={onThemeChange}
                snackbar={snackbar}
                dimensions={dimensions}
            />}
    </Wrapper>,
    document.getElementById('root')
);
